import { useBreakpoint } from 'gatsby-plugin-breakpoints';

export function useBreakpoints() {
  const breakpoints = useBreakpoint();
  return {
    isMobile: breakpoints.xs || breakpoints.sm || breakpoints.md,
  };
}
